'use client';

import { useTheme } from 'next-themes';
import { Moon, Sun } from 'lucide-react';
import { useAppStore } from '@/stores';

type ThemeToggleProps = {
	className?: string;
};

export function ThemeToggle({ className }: ThemeToggleProps): JSX.Element {
	const { resolvedTheme, setTheme } = useTheme();
	const { setUserPreferences } = useAppStore();

	const handleToggle = (): void => {
		const next = resolvedTheme === 'dark' ? 'light' : 'dark';
		setTheme(next);
		setUserPreferences({ theme: next });
	};

	return (
		<button
			type="button"
			onClick={handleToggle}
			className={`relative p-1.5 sm:p-2 hover:bg-purple-500/10 rounded-lg transition-colors active:scale-95 ${className ?? ''}`}
			aria-label={resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
		>
			<Sun className="w-5 h-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
			<Moon className="absolute top-1.5 left-1.5 sm:top-2 sm:left-2 w-5 h-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
			<span className="sr-only">Toggle theme</span>
		</button>
	);
}
